module.exports = __webpack_public_path__ + "img/icon-check-squared.bf91162c.svg";